import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CreateDataGroup } from 'containers/Jit/DataGroups/Components/DataGroupWizard/CreateDataGroup';

import { actions } from '../../slice';

export const EditDataGroup = () => {
  const dispatch = useDispatch();
  const params = useParams<{ id: string }>();

  useEffect(() => {
    if (!!params.id)
      dispatch(actions.getDataGroup({ q: { dataGroupId: params.id } }));
  }, [dispatch, params.id]);

  return <CreateDataGroup action="Update" />;
};
